/**
 * Article share
 *
 * The toggle is a disclosure that reveals a menu of share targets (real links
 * that work without JS) plus a clipboard "Copy link". Closes on outside-click
 * and Escape. Scoped to the `js-article-share` hook; bails if it's absent.
 */
export default class ArticleShare {
    constructor() {
        this.root = document.querySelector('.js-article-share');

        if (!this.root) {
            return;
        }

        this.toggle = this.root.querySelector('.js-article-share__toggle');
        this.menu = this.root.querySelector('.js-article-share__menu');
        this.copyButton = this.root.querySelector('.js-article-share__copy');
        this.url = this.root.dataset.shareUrl;
        this.isOpen = false;

        this.toggle.addEventListener('click', () => {
            this.isOpen ? this.closeMenu() : this.openMenu();
        });

        if (this.copyButton) {
            this.copyButton.addEventListener('click', () => this.copyLink());
        }

        document.addEventListener('click', (event) => {
            if (this.isOpen && !this.root.contains(event.target)) {
                this.closeMenu();
            }
        });

        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && this.isOpen) {
                this.closeMenu();
                this.toggle.focus();
            }
        });
    }

    openMenu() {
        this.menu.hidden = false;
        this.toggle.setAttribute('aria-expanded', 'true');
        this.isOpen = true;
    }

    closeMenu() {
        this.menu.hidden = true;
        this.toggle.setAttribute('aria-expanded', 'false');
        this.isOpen = false;
    }

    async copyLink() {
        const label = this.copyButton.querySelector('.js-article-share__copy-label');

        try {
            await navigator.clipboard.writeText(this.url);
        } catch (error) {
            return;
        }

        if (!label) {
            return;
        }

        const original = label.textContent;
        label.textContent = 'Link copied';

        window.setTimeout(() => {
            label.textContent = original;
        }, 2000);
    }
}
